import {useTranslation} from 'react-i18next'
import {createUseStyles} from 'react-jss'
import cssMobile from '../../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import ImageIcon from '../../icons/ImageIcon'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

const useStyles = createUseStyles({
  iconWrapper: {
    margin: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    alignItems: 'center',
  },
  text: {},
  icon: {},
  iconInverse: {
    backgroundColor: 'black',
    border: '1px solid black',
    borderRadius: 4,
    '& path': {
      fill: 'white',
    },
  },
  iconMonochrome: {
    '& path': {
      fill: 'black',
    },
  },
  iconSepia: {
    '& path': {
      fill: '#d59d64',
    },
  },
})

export default function FilterControls({open, onBackClick}: ControlsProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  const classes = useStyles()

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      {selectedImage && (
        <div className={cssMobile.controlItemsRow}>
          <div className={classes.iconWrapper}>
            <ImageIcon
              title={t('Inverz')}
              className={`${classes.icon} ${classes.iconInverse}`}
              onClick={() =>
                handleUpdatedAttributes(dispatch, selectedImage, {
                  filters: {
                    ...selectedImage.filters,
                    inverse: !selectedImage.filters.inverse,
                  },
                })
              }
            />
            <span className={classes.text}>{t('Inverz')}</span>
          </div>
          <div className={classes.iconWrapper}>
            <ImageIcon
              title={t('Fekete-fehér')}
              className={`${classes.icon} ${classes.iconMonochrome}`}
              onClick={() =>
                handleUpdatedAttributes(dispatch, selectedImage, {
                  filters: {
                    ...selectedImage.filters,
                    monochrome: !selectedImage.filters.monochrome,
                  },
                })
              }
            />
            <span className={classes.text}>{t('Fekete-fehér')}</span>
          </div>
          <div className={classes.iconWrapper}>
            <ImageIcon
              title={t('Szépia')}
              className={`${classes.icon} ${classes.iconSepia}`}
              onClick={() =>
                handleUpdatedAttributes(dispatch, selectedImage, {
                  filters: {
                    ...selectedImage.filters,
                    sepia: !selectedImage.filters.sepia,
                  },
                })
              }
            />
            <span className={classes.text}>{t('Szépia')}</span>
          </div>
        </div>
      )}
    </ControlsBase>
  )
}
